/**
 * Language/country localization helpers.
 * Header market selector uses native form submit; this only patches legacy markup.
 */
(function () {
  const LANGUAGE_COUNTRY_MAP = {
    en: 'US',
    ja: 'JP',
    es: 'ES',
    fr: 'FR',
    de: 'DE',
    ko: 'KR',
    it: 'IT',
    'pt-PT': 'PT',
    ms: 'MY',
    ru: 'RU',
    'zh-TW': 'TW',
    sv: 'SE',
    nl: 'NL',
    tr: 'TR',
    fi: 'FI',
  };

  function ensureCountryInput(form) {
    let input = form.querySelector('input[name="country_code"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'country_code';
      form.appendChild(input);
    }
    return input;
  }

  function submitMarketForm(form, locale, country) {
    const localeInput = form.querySelector('input[name="locale_code"]');
    const countryInput = form.querySelector('input[name="country_code"]');
    if (localeInput) localeInput.value = locale;
    if (countryInput) countryInput.value = country;
    form.submit();
  }

  function initMarketSync(wrapper) {
    if (wrapper.closest('.localization-market')) return;

    const form = wrapper.querySelector('form');
    if (!form || form.dataset.marketSyncReady === 'true') return;
    form.dataset.marketSyncReady = 'true';

    wrapper.querySelectorAll('[data-locale][data-country]').forEach((item) => {
      item.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          submitMarketForm(form, item.dataset.locale, item.dataset.country);
        },
        true
      );
    });
  }

  function initLanguageSync(wrapper) {
    const form = wrapper.querySelector('form');
    if (!form) return;

    wrapper.querySelectorAll('a[data-value]').forEach((link) => {
      link.addEventListener(
        'click',
        () => {
          const locale = link.dataset.value;
          const country = LANGUAGE_COUNTRY_MAP[locale];
          if (!country) return;
          ensureCountryInput(form).value = country;
        },
        true
      );
    });
  }

  function init() {
    document.querySelectorAll('[data-localization-type="market"]').forEach(initMarketSync);
    document.querySelectorAll('[data-localization-type="language"]').forEach(initLanguageSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
